// React
import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
// MUI
import { Grid, Box, Button, Container, Divider } from "@mui/material";
import Iconify from "../../../components/iconify/Iconify";
// Constants
import EntityConstants from "../../../configs/EntityConstants";
import MessageContants from "../../../configs/MessageContants";
// Service
import { get, post, put } from "../../../services/FetchHelper";
import SpinService from "../../../services/SpinService";
// Utils
import { DEBIT_NOTE_LINE_STATE, DEBIT_NOTE_LINE_SCHEMA, DEBIT_NOTE_LINE_FORM_FIELDS } from "./DebitNote.utils";
// Styles
import { StyledDrawerForm } from "../../../configs/GoStyles";
//Third party
import { Form, Formik } from "formik";
import GoForm from "../../../components/Inputs/GoForm";
import PermissionConstants from "../../../configs/PermissionConstants";
import usePermissions from "../../../hooks/usePermissions";
import toast from "react-hot-toast";

import { TableRow, TableCell } from "@mui/material";
import GoInlineField from "../../../components/Inputs/GoInlineField";

const DebitNoteLine = ({ values, touched, errors, handleChange, debitNoteId, debitNoteLineId, onClose }) => {
    const permissions = usePermissions();
    const spinService = SpinService();
    const [debit_note_line, setDebitNoteLine] = useState(DEBIT_NOTE_LINE_STATE);
    const [schema, setSchema] = useState(DEBIT_NOTE_LINE_SCHEMA);
    const [formFields, setFormFields] = useState(DEBIT_NOTE_LINE_FORM_FIELDS);

    const attachOptions = (name, options) => {
        setFormFields(prevFormFields =>
            prevFormFields.map(field =>
                field.name === name && (field.type === "select" || field.type === "autocomplete")
                    ? { ...field, options: options }
                    : field
            )
        );
    };

    const handleAccountChange = async () => {
        spinService.on();
        const response = await get(EntityConstants.ACCOUNTS, "max=all");
        const data = await response.json();
        attachOptions("credit_ledger_id", data);
        spinService.off();
    };

    const handleDebitNoteLineChange = async (debitNoteLineId) => {
        spinService.on();
        const response = await get(EntityConstants.DEBIT_NOTE_LINES + `/${debitNoteLineId}`);
        const data = await response.json();
        setDebitNoteLine(data);
        spinService.off();
    };

    const handleSubmit = async (values) => {
        spinService.on();
        const isNewDebitNoteLine = values.id === undefined;
        if (isNewDebitNoteLine) {
            values.debit_note_id = debitNoteId;
        }
        const url = isNewDebitNoteLine ? EntityConstants.DEBIT_NOTE_LINES : EntityConstants.DEBIT_NOTE_LINES + `/${values.id}`;
        const method = isNewDebitNoteLine ? post : put;
        const response = await method(url, { debit_note_line: values });
        if ([200, 201].indexOf(response.status) > -1) {
            toast.success(isNewDebitNoteLine ? MessageContants.DEBIT_NOTE_LINE_CREATED : MessageContants.DEBIT_NOTE_LINE_UPDATED);
            onClose();
        }
        spinService.off();
    };

    const handleValueChange = (e, values) => {
        console.log(e);
        console.log(values);
    };

    useEffect(() => {
        handleAccountChange();
        if (debitNoteLineId !== undefined) {
            handleDebitNoteLineChange(debitNoteLineId);
        }
        return () => {
            setDebitNoteLine({});
        }
    }, []);

    return (
        <TableRow
            hover
            key={"action_row"}
            tabIndex={-1}
            role="checkbox"
        >
            {formFields.map((formField, index) => {
                return (
                    <TableCell
                        colSpan={formField.colSpan === undefined ? 1 : formField.colSpan}
                        key={"col" + index}
                    // align={col.align}
                    >
                        <GoInlineField
                            config={formField}
                            values={values}
                            touched={touched}
                            errors={errors}
                            handleChange={(e) => { handleChange(e); handleValueChange(e, values); }}
                            onClose={() => onClose()}
                        />
                    </TableCell>
                );
            })}
        </TableRow>
    );
};

DebitNoteLine.propTypes = {
    debitNoteId: PropTypes.any,
    debitNoteLineId: PropTypes.any,
    onClose: PropTypes.any,
};

export default DebitNoteLine;